import RegionAuto from './../RegionAuto';
const displayData = (props) => {
    const {fillForms, columns, setType, regions} = props;
    return columns.map(column => {
        if(column.id === "btn") {
            return <th key={column.id} style={{width: 40}}></th>
        } else if(column.id === "user_id"){
            return <th key={column.id} style={{width: 120}}>
                <div className='input-areas' style={{textAlign: "left"}}>
                    <label>{column.label}</label>
                    <input placeholder={`Find by ${column.label}`} className='inputs' type="text" onChange={(e) => {fillForms(column.id, e.target.value)}}/>
                </div>
            </th>
        } else if (column.id === "region") {
            return <th key={column.id}> 
                <div className='input-areas' style={{textAlign: "left"}}>
                    <label>{column.label}</label>
                    <RegionAuto regions={regions} regionL={null} setType={setType}/> 
                </div>
            </th>
        } else{
            return <th key={column.id}>
                <div className='input-areas' style={{textAlign: "left"}}>
                    <label>{column.label}</label>
                    <input placeholder={`Find by ${column.label}`} className='inputs' type="text" onChange={(e) => {fillForms(column.id, e.target.value)}}/>
                </div>
            </th>
        }
    })
} 

export default displayData;